import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Input as BaseInput } from '@mui/base/Input';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { addTelxHistory, fetchInvoiceListForTelx, fetchTelxList, getSASToBlob } from "../../../api/po";
import { toast } from "react-toastify";
import axios from "axios";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import SweetAlert from "react-bootstrap-sweetalert";

const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const InputElement = styled('input')(
    ({ theme }) => `
    width: 120px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
        };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);
const Telx = () => {

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Telx'))

    const [showList, setShowList] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [invoiceList, setInvoiceList] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [file, setFile] = useState('');
    const [fileType, setFileType] = useState('');
    const [status, setStatus] = useState('Yes');
    const [approvalrows, setApprovalrows] = useState([]);
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const [message, setMessage] = useState('Telx was created successfully');
    const [isSubmitModalOpen, setSubmitModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const handleButtonClick = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };
    const toggleList = () => {
        setShowList(!showList);
    };
    const Input = React.forwardRef(function CustomInput(props, ref) {
        return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
    });
    document.title = "Dashboard | Procurement Dashboard";
    const productList = [
        { label: 'PO123844' },
        { label: 'PO654344' },
        { label: 'PO128448' },
        { label: 'PO342344' },
        { label: 'PO652344' },]

    const top100Films = [
        { label: '30% 30 Days' },
        { label: '30% 60 Days' },
        { label: 'No  60 Days' },
        { label: '30% 45 Days' },
        { label: '30% 15 Days' },]

    const columns = [
        {
            field: 'Sl_No', headerName: 'Sl.No', flex: .5,
            resizable: false,
            sortable: false,
        },
        {
            field: 'telx_file',
            headerName: 'Telx File',
            headerClassName: 'table-header-background',
            // width: 160,
            editable: false,
            resizable: false,
            sortable: false,
            flex: 1,
        },
        {
            field: 'Status',
            headerName: 'Status',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            resizable: false,
            maxWidth: 180,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            renderCell: (params) => {
                return <div>
                    <p className="mb-0">{params.value}</p>
                </div>;
            },
        },
        // {
        //     field: 'texl_file',
        //     headerName: 'Telx File Name',
        //     headerClassName: 'table-header-background',
        //     sortable: false,
        //     resizable: false,
        //     // width: 160,
        //     headerAlign: 'center',
        //     cellClassName: 'center-aligndata',
        //     flex: 1
        // },
        // {
        //     field: 'download_link',
        //     headerName: 'Texl File Upload',
        //     headerClassName: 'table-header-background',
        //     sortable: false,
        //     resizable: false,
        //     // width: 160,
        //     headerAlign: 'center',
        //     cellClassName: 'center-aligndata',
        //     flex: 1,
        //     renderCell: (params) => {
        //         if (params.value === '--') {
        //             return '--'; // If pi_file_upload value is '--', render '--'
        //         } else {
        //             return (
                        
        //                 <div>
        //                     <a href={params.value} target="_blank" rel="noopener noreferrer" className="download-link">
        //                         Download
        //                     </a>
        //                 </div>
        //             );
        //         }
        //     },
        // },
        // {
        //     field: 'upload_date',
        //     headerName: 'Telx Date',
        //     headerClassName: 'table-header-background',
        //     sortable: false,
        //     resizable: false,
        //     // width: 160,
        //     headerAlign: 'center',
        //     cellClassName: 'center-aligndata',
        //     flex: 1
        // },
      
    ];

    const fetchInvoiceListForTelxFromBackend = async () => {
        try {

          const response = await fetchInvoiceListForTelx();
            

          setInvoiceList(response.data.invoiceList.map(el => ({...el, label: el.invoice_number})));

        } catch (error) {
          toast.error("Error in fetching invoice data");
          console.log(error);
        }
      };

      const fetchTelxListFromBackend = async () => {
        try {

          const response = await fetchTelxList();
            
          const result = response.data.invoiceList.map((product, index) => ({
            id: product.id, // Assuming index + 1 as ID
            Sl_No: index + 1, // Serial Number
            texl_file: product.fileName? product.fileName:'--',
            download_link: product.download_link?  product.download_link : '--',
            Status: product.status,
            invoice_number: product.procurementInvoice.invoice_number,
            upload_date: dayjs(product.created_at).format('YYYY-MM-DD') ,
            }));
            
            setApprovalrows(result);

        } catch (error) {
          toast.error("Error in fetching invoice data");
          console.log(error);
        }
      };

      useEffect(() => {
        fetchInvoiceListForTelxFromBackend()
        fetchTelxListFromBackend();
      }, []);

    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);
    const onFileChange = (e) => {
        setFile(e.target.files[0]);
    };
    
    // const onFileChange = (e) => {
    //     const [file] = e.target.files;
    //     console.log(file);
    //     if(file?.size < 50000000){
    //         setFileType(file.type.split('/')[0]);
    //         setFile(e.target.files[0]);

    //     } else {
    //         setFile('');

    //     }
    // }

    const handleRadioChange = (event) => {
        setStatus(event.target.value);
      };

      const handleSubmit = async () => {
        try {
            
            /*
            {
                invoice_id: bigint
                fileName?: string
                blobName?: string
                status: string
            }

            */

            setSubmitModalOpen(true);


        } catch (error) {
            toast.error("Error in submitting invoice data");
            console.log(error);
        }
    }

    const submitRequisition = async () => {

        try{
         setIsLoading(true);
 
         const payload = {
            invoice_id: selectedInvoice.id,
            status: status
        };

        if (file) {
            const response =  await getSASToBlob({uploadType:'TELX'})
 
            const fetchOptions = {
                method: 'PUT',
                body: file,
                headers: {
                    'x-ms-blob-type': 'BlockBlob',
                    'Content-Type': file.type 
                },
            }
             if(response.statusCode===200 && response.data.preSignedUrl){
                
                 try {
                     const res = await fetch(response.data.preSignedUrl, fetchOptions);
         
                     if (res.ok) {
                        payload.blobName = response.data.blobName
                        payload.fileName = file.name
                     }
                 } catch (error) {
                     console.error('Error uploading file:', error);
                     toast.error('Error uploading file')
                     return
                 }
                 
             }
         }

        
        let response = await addTelxHistory(payload);
        
        if(response.statusCode == 200){
            setMessage(`Telx was created successfully for invoice no: ${selectedInvoice.invoice_number}`);
            setSubmitModalOpen(false);
            setIsOpenSweetAlert(true);
            setSelectedInvoice(null);
            fetchInvoiceListForTelxFromBackend();
            fetchTelxListFromBackend();
        }
 
         } catch (error) {
             toast.error("Error in submitting invoice data");
             console.log(error);
         } finally {
             setIsLoading(false);
         }
     };

    useEffect(() => {
        
            setStatus('Yes');
            setFile('');
        
    }, [selectedInvoice]);

    const handleSweetAlertConfirm = () => {
        setIsOpenSweetAlert(false);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <Card>
                            <CardBody>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div className='d-flex align-items-center mb-2 gap-4'>
                                        <div className="d-flex align-items-center gap-2">
                                            <p className='mb-0 me-2 requisition_type_text'>
                                                {/* Invoice No */}
                                                Telx
                                            </p>
                                            <div>
                                                <Autocomplete
                                                    className="invoice_autofield"
                                                    // id={`product-category`}
                                                    sx={{ width: 190 }}
                                                    options={invoiceList}
                                                    onChange={(e, value) => setSelectedInvoice(value)}
                                                    value={selectedInvoice}
                                                    // value={productCategoryObj.find(option => option.value === productCategory)}
                                                    // onChange={handleProductCategoryChange}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Invoice"
                                                        />
                                                    )}
                                                />

                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center gap-4" style={{borderRight:'2px solid rgb(175 172 172)'}}>
                                            <p className="mb-0">Status</p>
                                            <FormControl>
                                                <RadioGroup
                                                className="status-radio"
                                                    row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                    value={status}
                                                    onChange={handleRadioChange}
                                                >
                                                    <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                    <FormControlLabel value="No" control={<Radio />} label="No" />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                        <div className='d-flex align-items-center gap-2'>
                                            <p className="mb-0">Telx Upload</p>
                                            <div className="upload-btn-wrapper ms-2">
                                                <button className="btn">Upload</button>
                                                <input type="file" name="myfile" onChange={(e) => onFileChange(e)} />
                                                {file && <p className="mb-0" style={{ color: "#0060AA" }}>{file.name}</p>}

                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-end">
                                            <button className="assign_vendor" onClick={handleSubmit}>Submit</button>
                                 </div>
                                </div>
                            </CardBody>
                        </Card>
                        <div>
                            <div>
                                <h4 className="mb-0 requisition_text">Telx List</h4>
                            </div>
                            <Box sx={{ height: '100%', width: '100%', marginBottom: '1.5rem', marginTop: '10px' }}>
                                <DataGrid
                                    autoHeight
                                    className="table_header_background"
                                    headerClassName="custom-header-cell"
                                    getRowHeight={() => 'auto'}
                                    rows={approvalrows}
                                    columns={columns}
                                    initialState={{
                                        // pagination: {
                                        //     paginationModel: {
                                        //         pageSize: 5,
                                        //     },
                                        // },
                                    }}
                                    pageSizeOptions={[]}
                                    disableRowSelectionOnClick
                                    disableColumnMenu
                                    disableColumnResize={true}
                                    componentsProps={{
                                        cell: {
                                            disableClick: true,
                                        },
                                    }}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                            '& .MuiDataGrid-cell--textOverflow': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            },
                                        },
                                    }}
                                />
                            </Box>
                        </div>
                    </div>
                </Container>
            </div>
            <Modal
                isOpen={isSubmitModalOpen}
                onRequestClose={() => setSubmitModalOpen(false)}
                contentLabel="Example Modal"
                className="change_modalbox generatePo_modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Do you want to create this Telx?</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={() => setSubmitModalOpen(false)}></i>
                    </div>
                </div>
                {/* <hr className='mb-2 mt-1 ms-3 me-3'></hr> */}
                <ModalBody className='pt-2'>
                    <div>
                    <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>Invoice Number</th>
                                            
                                            <th>Status</th>
                                        </tr>
                                    </thead>
             

                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td>{selectedInvoice?.label}</td>
                                                
                                                <td>{status}</td>
                                            </tr>
                                        
                                    </tbody>
                                    {/* <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="3">Total :</th>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.total_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.received_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.unit_price;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + (currentObject.unit_price * currentObject.received_qty * payload.conversion_rate);
                                                }, 0)}</td>
                                        </tr>
                                    </tfoot> */}
                                </table>
                    </div>
                    <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" disabled={isLoading} onClick={submitRequisition}>
                            Yes
                        </button>
                        <button className="no_button d-flex align-items-center ms-3" onClick={() => setSubmitModalOpen(false)}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <SweetAlert
                show={isOpenSweetAlert}
                title={message}
                success
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                onConfirm={handleSweetAlertConfirm} // Updated to handleSweetAlertConfirm function

            />
        </React.Fragment>
    );
};

export default Telx;
